<template>
    <div class="py-3 px-6 pt-1">
        <DForm>
            <div
                v-for="filter in filtersWithComponent"
                :key="filter.id"
                :data-cy="`filters-modal-filter-${filter.type}`"
            >
                <!-- Nested groups will just display inline -->
                <component
                    :is="filter.component"
                    v-if="filter.component"
                    :filter="filter"
                    :filter-uuid="filterUuid"
                    :model-value="localValue[filter.id]"
                    @update:model-value="updateFilterValue(filter, $event)"
                />
            </div>
        </DForm>
    </div>
</template>

<script setup>
    import { cloneDeep, isEmpty } from 'lodash'
    import { DForm } from '@digistorm/spark'
    import { useFilters } from '@/composables'

    const { modalComponentForFilter } = useFilters()

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        filterUuid: String,
        filter: Object,
        modelValue: String,
    })

    const localValue = ref()

    const filtersWithComponent = computed(() => {
        return props.filter.filters.map((filter) => {
            return {
                ...filter,
                component: modalComponentForFilter(filter),
            }
        })
    })

    const handleChange = (value) => {
        if (isEmpty(value)) {
            value = null
        }
        emit('update:modelValue', value)
    }

    const updateFilterValue = (filter, filterValue) => {
        if (filterValue === null) {
            delete localValue.value[filter.id]
        } else {
            localValue.value[filter.id] = filterValue
        }
        handleChange(localValue.value)
    }

    watch(props.modelValue, () => {
        localValue.value = cloneDeep(props.modelValue || {})
    }, { immediate: true })
</script>
